// extracted by mini-css-extract-plugin
export default {"foCell":"Cell_foCell__lZZtw"};